export const hasLetters = (code) => /[a-zA-Z]/.test(code)
